import { BlockType } from '@backmarket/http-api/src/api-specs-content'

export const FULL_WIDTH_COMPONENTS: BlockType[] = [
  BlockType.Carousel,
  BlockType.Faq,
]
